<template>
	<report-page
		v-if="products.length > 0"
		:start-date="true"
		:end-date="true"
		:products="products"
		get-url="/bo/report/datascience/claimevents"
		title="Claim Status Transitions Data Export"
		export-filename="claim_status_transition_data_export"
	/>
</template>

<script>
import {
	axios,
} from '../../../../../../services/axios-service.js';

export default {
	name: 'DatascienceClaimeventExport',

	data () {
		return {
			products: []
		};
	},

	created () {
		axios.get('/api/v0/products/available').then(({
			data: data
		}) => {
			this.products = data.map((product) => {
				return {
					id: product.id,
					name: `${product.name} - ${product.domain}`
				};
			});
		});
	},
};
</script>
